import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import userReducer from './slices/userSlice';
import exhibitReducer from './slices/exhibitSlice';
import navigationReducer from './slices/navigationSlice';
import zonesReducer from './slices/zonesSlice';

// Persist configuration
const persistConfig = {
    key: 'root',
    storage,
    // Only persist user and exhibit data, not navigation or zones state
    // Zones should be ephemeral and reflect real-time server state
    whitelist: ['user', 'exhibit']
};

// Combine reducers
const rootReducer = combineReducers({
    user: userReducer,
    exhibit: exhibitReducer,
    navigation: navigationReducer,
    zones: zonesReducer,
});

// Create persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
            },
        }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch; 